import React from 'react';
import {
  Plus,
  Sparkles,
  FileText,
  Sliders,
  Settings,
} from 'lucide-react';
import { useSite } from '../../context/SiteContext';

interface MobileEditorBottomBarProps {
  onOpenAddSection: () => void;
  onOpenAiGenerator: () => void;
  onOpenPageSheet: () => void;
  onOpenSettings: () => void;
}

export const MobileEditorBottomBar: React.FC<MobileEditorBottomBarProps> = ({
  onOpenAddSection,
  onOpenAiGenerator,
  onOpenPageSheet,
  onOpenSettings,
}) => {
  const { selectedSectionId } = useSite();

  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-slate-900/95 border-t border-slate-800 backdrop-blur-md px-3 py-2 flex items-center justify-around text-slate-400 select-none pb-safe">
      {/* 1. Add Section */}
      <button
        type="button"
        onClick={onOpenAddSection}
        className="flex flex-col items-center gap-1 py-1 px-2.5 rounded-xl hover:text-white hover:bg-slate-800/80 active:scale-95 transition"
      >
        <div className="w-8 h-8 rounded-full bg-blue-600 text-white flex items-center justify-center shadow-lg shadow-blue-600/30">
          <Plus className="w-4 h-4" />
        </div>
        <span className="text-[10px] font-bold text-slate-200">Bölüm Ekle</span>
      </button>

      {/* 2. AI Wizard */}
      <button
        type="button"
        onClick={onOpenAiGenerator}
        className="flex flex-col items-center gap-1 py-1 px-2.5 rounded-xl hover:text-white hover:bg-slate-800/80 active:scale-95 transition"
      >
        <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-indigo-600 to-sky-500 text-white flex items-center justify-center shadow-md">
          <Sparkles className="w-4 h-4" />
        </div>
        <span className="text-[10px] font-bold text-slate-200">AI Asistan</span>
      </button>

      {/* 3. Pages Switcher */}
      <button
        type="button"
        onClick={onOpenPageSheet}
        className="flex flex-col items-center gap-1 py-1 px-2.5 rounded-xl hover:text-white hover:bg-slate-800/80 active:scale-95 transition"
      >
        <div className="w-8 h-8 rounded-full bg-slate-800 border border-slate-700 text-slate-200 flex items-center justify-center">
          <FileText className="w-4 h-4 text-cyan-400" />
        </div>
        <span className="text-[10px] font-bold text-slate-300">Sayfalar</span>
      </button>

      {/* 4. Section Properties / Settings */}
      <button
        type="button"
        onClick={onOpenSettings}
        className="flex flex-col items-center gap-1 py-1 px-2.5 rounded-xl hover:text-white hover:bg-slate-800/80 active:scale-95 transition"
      >
        <div className="w-8 h-8 rounded-full bg-slate-800 border border-slate-700 text-slate-200 flex items-center justify-center relative">
          {selectedSectionId ? (
            <>
              <Sliders className="w-4 h-4 text-emerald-400" />
              <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-emerald-500 rounded-full ring-2 ring-slate-900" />
            </>
          ) : (
            <Settings className="w-4 h-4 text-slate-300" />
          )}
        </div>
        <span className="text-[10px] font-bold text-slate-300">
          {selectedSectionId ? 'Bölüm Ayarı' : 'Genel Ayar'}
        </span>
      </button>
    </div>
  );
};
